export const Z_OVERLAY = 9999
export const Z_OVERLAY_MODAL = 10000
